"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var SummaryContext_1 = require("./SummaryContext");
function useSummaryContext() {
    var summaryContext = react_1.useContext(SummaryContext_1.default);
    return __assign({}, summaryContext);
}
exports.default = useSummaryContext;
